import React, { useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { FocusableActuator } from '@bingads-webui-campaign-react/actuator';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { withAlwaysShowError, andComp, propertyIs, entityIs } from '@bingads-webui-campaign-react/form-error';
import { useResponsiveStyles } from '@bingads-webui-campaign-react/common-hooks';
import { ErrorMessages } from '@bingads-webui-react/validation';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/pmax-common';

import { SectionDescription } from './section-description';
import { ImageListBeaconAdapter } from './image-list-beacon-adapter';
import { getImageExperienceStyles } from './image-experience-styles';

const entityIsAssetGroup = entityIs(ERROR_ENTITY.AssetGroup);
const assetGroupImagesProp = andComp(entityIsAssetGroup, propertyIs('Images'));

export const ImageListInternal = (props) => {
  const {
    i18n,
    validationProps,
    imageListState,
    imagesContainerRef,
  } = props;

  const {
    isDirty,
    errorMessages,
  } = imageListState;

  const stylingProps = useMemo(() => ({ component: { previewLabel: i18n.getString(_TL_('Preview')) } }), [i18n]);
  const getStyles = useResponsiveStyles(getImageExperienceStyles, stylingProps);

  return (
    <div className={classNames('image-list-container', getStyles('imageListContainer'))}>
      <SectionDescription text={i18n.getString(_TL_('You can add up to 20 images to your ad. We recommend that you add two to three relevant images.'))} />
      <div ref={imagesContainerRef} />
      <ErrorMessages messages={(isDirty || validationProps.alwaysShowError) && errorMessages} />
    </div>
  );
};

ImageListInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  validationProps: PropTypes.shape({
    alwaysShowError: PropTypes.bool,
  }),
  imageListState: PropTypes.shape({
    isDirty: PropTypes.bool,
    errorMessages: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  imagesContainerRef: PropTypes.shape({}).isRequired,
};

ImageListInternal.defaultProps = {
  validationProps: {},
};

// eslint-disable-next-line max-len
export const ImageList = withAlwaysShowError(withUnvalidatedControlErrors(withControlErrorHandling(ImageListInternal, [FocusableActuator], [ImageListBeaconAdapter]), { filter: assetGroupImagesProp }));
